import React from 'react'
import { ExternalLink, Shield, FileText, LayoutGrid } from 'lucide-react'

const Footer = () => {
    const otherTools = [
        { name: 'Free Image Editor', url: 'https://free-image-editor.aifree-tools.com/' },
        { name: 'SVG Converter', url: 'https://svgconverter.aifree-tools.com/' },
        { name: 'QR Generator', url: 'https://qrgeneretor.aifree-tools.com/' },
        { name: 'Color Picker', url: 'https://colorpicker.aifree-tools.com/' },
        { name: 'Slug Generator', url: 'https://sluggeneretor.aifree-tools.com/' },
        { name: 'Image to PDF', url: 'https://imagetopdf.aifree-tools.com/' },
        { name: 'Background Remover', url: 'https://bgremove.aifree-tools.com/' },
        { name: 'PDF to WebP', url: 'https://pdftowebp.aifree-tools.com/' },
        { name: 'PDF to PNG', url: 'https://pdftopng.aifree-tools.com/' },
        { name: 'GST Calculator', url: 'https://gstcalculator.aifree-tools.com/' },
        { name: 'World Time Converter', url: 'https://worldtimeconvertor.aifree-tools.com/' },
        { name: 'Image Resizer', url: 'https://imageresizer.aifree-tools.com/' },
    ]

    return (
        <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 pt-16 pb-8">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
                    {/* Brand section */}
                    <div className="space-y-4">
                        <h2 className="text-2xl font-bold text-primary-600 dark:text-primary-400">
                            Voice Converter Pro
                        </h2>
                        <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
                            Experience the power of advanced AI voice synthesis. Transform your text into natural-sounding speech across multiple languages and accents effortlessly.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6 flex items-center gap-2">
                            <Shield className="w-5 h-5 text-primary-500" />
                            Legal Links
                        </h3>
                        <ul className="space-y-4">
                            <li>
                                <a
                                    href="https://aifree-tools.com/privacy-policy-2/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors flex items-center gap-2"
                                >
                                    <Shield className="w-4 h-4" />
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://aifree-tools.com/terms-coonditions/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors flex items-center gap-2"
                                >
                                    <FileText className="w-4 h-4" />
                                    Terms & Conditions
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Other Tools Column 1 */}
                    <div className="lg:col-span-2">
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6 flex items-center gap-2">
                            <LayoutGrid className="w-5 h-5 text-primary-500" />
                            Our Other Free Tools
                        </h3>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
                            {otherTools.map((tool, index) => (
                                <a
                                    key={index}
                                    href={tool.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors flex items-center gap-2 text-sm group"
                                >
                                    <ExternalLink className="w-3.5 h-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                                    {tool.name}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Bottom copyright */}
                <div className="pt-8 border-t border-gray-100 dark:border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-gray-500 dark:text-gray-500 text-sm">
                        © {new Date().getFullYear()} Voice Converter Pro. All rights reserved.
                    </p>
                    <div className="flex items-center gap-6">
                        <span className="text-gray-400 dark:text-gray-600 text-xs uppercase tracking-widest font-semibold italic">
                            Powered by AI Free Tools
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
